import { FC } from 'react';
import { UnicodeEntity } from '@mews/enums';
import { LocalizedText, TimeUnitUtils, useTimezone } from '@mews/framework';
import { getServiceTimeUnit } from '@mews-commander/legacy-entities/src/ducks/services';
import {
    getServiceTimeUnitPluralKey,
    getServiceTimeUnitSingularKey,
} from '@mews-commander/legacy-entities/src/utils/serviceTimeUnitLocalization';
import { useCommanderSelector } from '@mews-commander/utils';

interface AvailabilityBlockTimeUnitCountProps {
    serviceId: string;
    startUtc: string;
    endUtc: string;
}

export const AvailabilityBlockTimeUnitCount: FC<AvailabilityBlockTimeUnitCountProps> = ({
    serviceId,
    startUtc,
    endUtc,
}) => {
    const timeUnit = useCommanderSelector((state) => getServiceTimeUnit(state, { id: serviceId }));
    const timezone = useTimezone();
    const timeUnitSingularKey = useCommanderSelector((state) =>
        getServiceTimeUnitSingularKey(state, { id: serviceId })
    );
    const timeUnitPluralKey = useCommanderSelector((state) => getServiceTimeUnitPluralKey(state, { id: serviceId }));

    if (!timeUnit) {
        return null;
    }

    const timePart = TimeUnitUtils.timeUnitToDateTimePart(timeUnit);
    const timeUnitCount = TimeUnitUtils.getTimeUnitDiff(startUtc, endUtc, timezone, timePart);
    const timeUnitKey = timeUnitCount && timeUnitCount > 1 ? timeUnitPluralKey : timeUnitSingularKey;

    return (
        <>
            {timeUnitCount}
            {UnicodeEntity.NoBreakSpace}
            {timeUnitKey && <LocalizedText textKey={timeUnitKey} firstLowerCase />}
        </>
    );
};
